// extracted by mini-css-extract-plugin
export var smallSpinner = "_wv-0";